export const isFilterActive = (filters, filterType, value) => {
    const valuesToCheck = Array.isArray(value) ? value : [value];
    return filters.some((group) => {
        if (group.param !== filterType) {
            return false;
        }
        const groupItems = group.items.filter((item) => item.checked);
        return groupItems.some((item) => {
            if (Array.isArray(item.value)) {
                return item.value.some((v) => valuesToCheck.includes(v));
            }
            return valuesToCheck.includes(item.value);
        });
    });
};
